<template>
  <Header></Header>
  <SideBar></SideBar>

  <Body pageTitle="Schedule Template">
    <template v-slot:body>
      <TableList :config="config()"></TableList>
    </template>
  </Body>
</template>

<script>
import Header from '@/layouts/Header.vue'
import SideBar from '@/layouts/SideBar.vue'
import Body from '@/layouts/Body.vue'
import TableList from './TableList.vue'
export default {
  components: {
    Header,
    SideBar,
    Body,
    TableList
  },
  methods: {
    config() {
      return {
        showTableFilters: true,
        preload: true,
        tableId: 'schedule-template',
        indexUri: 'schedule-template',
        storeId: ['main']
      }
    }
  }
}
</script>
<style lang="scss">
.schedule-template {
  .img-preview-wrapper:empty {
    padding: 0 !important;
  }
  a[href='#add-delivery'] {
    margin-top: -25px;
  }
}
</style>
